import { BaseTile } from "Components/BaseTile";
import { useTileTexts } from "Store/texts/hooks";
import React from "react";
import { ProductBackendName } from "../../Products/productTypes";
import { BankIdLogin } from "./BankIdLogin";
import { useBankIdLoginHandler } from "./bankIdLoginHooks";
import { StyledIngress } from "./styled";

interface Props {
  productBackendName: ProductBackendName;
}

export const HealthLogin = ({
  productBackendName,
}: Props): React.ReactElement => {
  const [
    {
      loginTile: { headers, descriptions },
    },
    lang,
  ] = useTileTexts();

  const header = headers[productBackendName][lang];
  const description = descriptions[productBackendName][lang];
  const handleBankIdLogin = useBankIdLoginHandler();

  return (
    <BaseTile header={header}>
      <StyledIngress>{description}</StyledIngress>
      <BankIdLogin handleLogin={() => handleBankIdLogin()} />
    </BaseTile>
  );
};
